var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-[0]",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._l((_vm.parts),function(part,index){return [(_vm.isMatch(index))?_c('span',{key:index,staticClass:"primary text-white text-sm"},[_vm._v(_vm._s(_vm.filter))]):_c('span',{staticClass:"text-sm"},[_vm._v(_vm._s(part))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }